import { Truncate } from "@lazarentertainment/web-design-system/components/truncate"
import ImagePlaceholder from "assets/icons/imagePlaceholder.svg"
import { Button } from "client/designSystem/Button"
import { scaleShopifyImageUrl } from "commerce/utils"
import { FormattedMessage } from "react-intl"

import { DEFAULT_VARIANT_TITLE } from "../../constants"
import { useCartContext } from "../cart/CartContext"
import { AddedToCartItem } from "../ShopContext"

import styles from "./AddedToCartConfirmation.module.css"

export type AddedToCartConfirmationProps = {
  item: AddedToCartItem
  handleShowCart?: () => void
  continueShopping?: () => void
  dismissModal?: () => void
}

const AddedToCart = ({
  item: { variant, quantity },
  continueShopping = () => {},
  handleShowCart = () => {},
  dismissModal = () => {},
}: AddedToCartConfirmationProps) => {
  const { cart } = useCartContext()

  return (
    <>
      <div
        className={styles.addedToCartClickAway}
        onClick={dismissModal}
      />
      <div className={styles.addedToCartPanel}>
        <p className={`title-sm ${styles.addedToCartText}`}>
          <FormattedMessage
            id="cart.confirmation"
            defaultMessage="Added to cart!"
          />
        </p>
        <div className={styles.addedToCartProductSection}>
          <div className={styles.addedToCartProductImageContainer}>
            {variant.image ? (
              <img
                src={scaleShopifyImageUrl(variant.image.url)}
                alt={variant.title}
                className={styles.addedToCartProductImage}
              />
            ) : (
              <ImagePlaceholder />
            )}
          </div>
          <div>
            <Truncate
              lineCount={2}
              className={`title-sm ${styles.addedToCartProductTitle}`}
              containerElement="h2"
            >
              {variant.product.title}
            </Truncate>
            {variant.title !== DEFAULT_VARIANT_TITLE && (
              <p className={`body-md ${styles.addedToCartProductVariant}`}>
                {variant.title}
              </p>
            )}
            <p className={`body-md ${styles.addedToCartProductQuantity}`}>
              <FormattedMessage
                id="confirmation.viewCart"
                defaultMessage="Qty: {quantity}"
                values={{ quantity }}
              />
            </p>
          </div>
        </div>
        <Button
          variant="primary"
          onClick={handleShowCart}
          data-robot="added-to-cart-view-cart"
        >
          <FormattedMessage
            id="confirmation.viewCart"
            defaultMessage="View Cart ( {quantity} )"
            values={{ quantity: cart?.totalQuantity ?? 0 }}
          />
        </Button>
        <Button
          variant="secondary"
          onClick={continueShopping}
          data-robot="added-to-cart-continue-shopping"
        >
          <FormattedMessage
            id="confirmation.continueShopping"
            defaultMessage="Continue Shopping"
          />
        </Button>
      </div>
    </>
  )
}

export default AddedToCart
